(() => {
  'use strict';
  if (window.mgVintageCommerceBridge) return;
  window.mgVintageCommerceBridge = true;

  function prepareVoucher(root) {
    if (root.dataset.mgVintageBridge === 'true') return;
    root.dataset.mgVintageBridge = 'true';
    const form = root.querySelector('.mg-gcp__form');
    if (!form) return;
    const sender = form.querySelector('[data-mg-sender-name]');
    const property = form.querySelector('[data-mg-sender-name-property]');
    const summary = root.querySelector('[data-mg-summary-from]');
    const syncSender = () => {
      const value = sender ? sender.value.trim() : '';
      if (property) property.value = value;
      if (summary) summary.textContent = value || 'Your name';
    };
    sender?.addEventListener('input', syncSender);
    sender?.addEventListener('change', syncSender);
    form.addEventListener('submit', syncSender, true);
    syncSender();
  }

  function initialise(scope = document) {
    scope.querySelectorAll('[data-mg-gift-card-product]').forEach(prepareVoucher);
    if (scope.matches?.('[data-mg-gift-card-product]')) prepareVoucher(scope);
  }

  document.addEventListener('cart:refresh', (event) => {
    if (event.detail?.source !== 'mg-v36-bundle-builder' || window.MGCart) return;
    const cart = window.theme?.miniCart;
    if (cart && typeof cart.generateCart === 'function' && typeof cart.updateElements === 'function') {
      try {
        cart.generateCart();
        cart.updateElements();
        return;
      } catch (error) {
        console.warn('[Mr Golf] Cart drawer refresh failed.', error);
      }
    }
    // The bundle has already been added. Never issue a second cart/add request.
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('Cart refresh unavailable');
        return response.json();
      })
      .then((cartData) => {
        document.querySelectorAll('.js-cart-count').forEach((node) => { node.textContent = String(cartData.item_count); });
      })
      .catch((error) => console.warn('[Mr Golf] Cart count refresh failed.', error));
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-mg-gift-card-product]').forEach((root) => {
      const selected = root.querySelector('[data-mg-variant]:checked');
      const submit = root.querySelector('[data-mg-submit]');
      const mobile = root.querySelector('[data-mg-mobile-submit]');
      if (!selected) return;
      if (submit) {
        submit.disabled = selected.disabled;
        const label = submit.querySelector('span');
        if (label) label.textContent = 'Add gift voucher';
      }
      if (mobile) mobile.disabled = selected.disabled;
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
